import React from "react";
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import Loader from "../../Loader/loader";

export const SubmitTicketForm = () => {
    const { loaded, error, formCreated } = useHubspotForm({
        portalId: '22438271',
        formId: 'c911e249-acef-4da5-8f09-3104ebc53bf6',
        target: '#submit-ticket-form'
    });

    return (
        <div className="mt-4">
            {(loaded && formCreated) ? <div id="submit-ticket-form"></div> : <Loader />}
        </div>
    );
};

